import { Directive } from '@angular/core';

@Directive({
  selector: '[snPlayerContent]',
  host: {
    class: 'sn-player__content',
  },
})
export class SnPlayerContentDirective {
  constructor() {}
}
